import { render } from "./AnimateText.vue?vue&type=template&id=cfb81aaa"
import script from "./AnimateText.vue?vue&type=script&lang=js"
export * from "./AnimateText.vue?vue&type=script&lang=js"
script.render = render

export default script